// 此文件不要动
export const nameComponentObj = {
  "systemConfigManage": {
    name: "systemConfigManage",
    label: "系统管理/配置管理",
    permissionIdentification: "system:config:list", // 权限标识
    recycleBinIdentification: "System.Config", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/config-manage")
  },
  "systemUserManage": {
    name: "systemUserManage",
    label: "系统管理/用户管理",
    permissionIdentification: "system:user:list", // 权限标识
    recycleBinIdentification: "System.User", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/user-manage")
  },
  "systemDictManage": {
    name: "systemDictManage",
    label: "系统管理/字典管理",
    permissionIdentification: "system:dict:list", // 权限标识
    recycleBinIdentification: "System.Dict", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/dict-manage")
  },
  "systemDictItemManage": {
    name: "systemDictItemManage",
    label: "系统管理/字典项管理",
    permissionIdentification: "system:dictItem:list", // 权限标识
    recycleBinIdentification: "System.DictItem", // 数据库表权限标识 回收站使用
    hidden: true,
    component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/dict-item-manage")
  },
  "systemRoleManage": {
    name: "systemRoleManage",
    label: "系统管理/角色管理",
    permissionIdentification: "system:role:list", // 权限标识
    recycleBinIdentification: "System.Role", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/role-manage")
  },
  "systemMenuManage": {
    name: "systemMenuManage",
    label: "系统管理/菜单管理",
    permissionIdentification: "system:menu:list", // 权限标识
    recycleBinIdentification: "System.Menu", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/menu-manage")
  }
}

// key 必须为 唯一值
export const btnObj = {
  systemMenuCreate: {
    label: "系统管理/菜单管理/新增菜单",
    value: "system:menu:create"
  },
  systemMenuRead: {
    label: "系统管理/菜单管理/查看菜单",
    value: "system:menu:read"
  },
  systemMenuUpdate: {
    label: "系统管理/菜单管理/更新菜单",
    value: "system:menu:update"
  },
  systemMenuDelete: {
    label: "系统管理/菜单管理/删除菜单",
    value: "system:menu:delete"
  },
  systemMenuStatus: {
    label: "系统管理/菜单管理/修改状态",
    value: "system:menu:status"
  },
  systemRoleCreate: {
    label: "系统管理/角色管理/新增角色",
    value: "system:role:create"
  },
  systemRoleDelete: {
    label: "系统管理/角色管理/删除角色",
    value: "system:role:delete"
  },
  systemRoleUpdate: {
    label: "系统管理/角色管理/更新角色",
    value: "system:role:update"
  },
  systemRoleRead: {
    label: "系统管理/角色管理/查看角色",
    value: "system:role:read"
  },
  systemRoleStatus: {
    label: "系统管理/角色管理/修改状态",
    value: "system:role:status"
  },
  systemRoleUser: {
    label: "系统管理/角色管理/分配用户",
    value: "system:role:user"
  },
  systemRoleMenu: {
    label: "系统管理/角色管理/分配菜单",
    value: "system:role:menu"
  },
  systemUserCreate: {
    label: "系统管理/用户管理/新增用户",
    value: "system:user:create"
  },
  systemUserDelete: {
    label: "系统管理/用户管理/删除用户",
    value: "system:user:delete"
  },
  systemUserUpdate: {
    label: "系统管理/用户管理/更新用户",
    value: "system:user:update"
  },
  systemUserRead: {
    label: "系统管理/用户管理/查看用户",
    value: "system:user:read"
  },
  systemUserStatus: {
    label: "系统管理/用户管理/修改状态",
    value: "system:user:status"
  },
  systemUserRole: {
    label: "系统管理/用户管理/分配角色",
    value: "system:user:role"
  },
  systemUserReset: {
    label: "系统管理/用户管理/重置密码",
    value: "system:user:reset"
  },
  systemUserExport: {
    label: "系统管理/用户管理/导出用户",
    value: "system:user:export"
  },
  systemUserImport: {
    label: "系统管理/用户管理/导入用户",
    value: "system:user:import"
  },
  systemDictCreate: {
    label: "系统管理/字典管理/新增字典",
    value: "system:dict:create"
  },
  systemDictDelete: {
    label: "系统管理/字典管理/删除字典",
    value: "system:dict:delete"
  },
  systemDictUpdate: {
    label: "系统管理/字典管理/更新字典",
    value: "system:dict:update"
  },
  systemDictRead: {
    label: "系统管理/字典管理/查看字典",
    value: "system:dict:read"
  },
  systemDictStatus: {
    label: "系统管理/字典管理/修改状态",
    value: "system:dict:status"
  },
  systemDictItemCreate: {
    label: "系统管理/字典项管理/新增字典项",
    value: "system:dictItem:create"
  },
  systemDictItemDelete: {
    label: "系统管理/字典项管理/删除字典项",
    value: "system:dictItem:delete"
  },
  systemDictItemUpdate: {
    label: "系统管理/字典项管理/更新字典项",
    value: "system:dictItem:update"
  },
  systemDictItemRead: {
    label: "系统管理/字典项管理/查看字典项",
    value: "system:dictItem:read"
  },
  systemDictItemStatus: {
    label: "系统管理/字典项管理/字典项状态",
    value: "system:dictItem:status"
  },
  systemConfigCreate: {
    label: "系统管理/配置管理/新增配置项",
    value: "system:config:create"
  },
  systemConfigDelete: {
    label: "系统管理/配置管理/删除配置项",
    value: "system:config:delete"
  },
  systemConfigUpdate: {
    label: "系统管理/配置管理/更新配置项",
    value: "system:config:update"
  },
  systemConfigRead: {
    label: "系统管理/配置管理/查看配置项",
    value: "system:config:read"
  },
  systemConfigStatus: {
    label: "系统管理/配置管理/修改状态",
    value: "system:config:status"
  }
}